import { RadioButton, RadioButtonGroup } from '@hover/blueprint';
import React from 'react';

const spaceTypes = [
  'exterior',
  'bathroom',
  'kitchen',
  'bedroom',
  'living_room',
  'dining_room',
  'entry',
  'office',
  'recreation_room',
  'sunroom',
  'other',
];

const SpaceTypeSelector = ({
  spaceType,
  setSpaceType,
}: {
  spaceType: string;
  setSpaceType: (type: string) => void;
}) => (
  <RadioButtonGroup
    display="flex"
    flexDirection="row"
    flexWrap="wrap"
    gap={200}
    value={spaceType}
  >
    {spaceTypes.map(type => (
      <RadioButton
        key={type}
        onClick={() => setSpaceType(type)}
        size={{ base: 'small', tablet: 'medium', desktop: 'large' }}
        textTransform="capitalize"
        value={type}
      >
        {type.replace(/_/g, ' ')}
      </RadioButton>
    ))}
  </RadioButtonGroup>
);

export { SpaceTypeSelector };
